import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom'
import DashboardHeader from '../shared/components/DashboardHeader';
import SideMenu from '../shared/components/SideMenu';
import Footer from '../shared/components/Footer';
import User from '../shared/Utils/User';
import axios from 'axios';
import Alert from '../shared/Utils/AlertBox';
import Moment from 'react-moment';
import Loader from '../shared/components/Loader';
import HttpCall from '../api/Http';
import SerializeClass from '../shared/Utils/serialized';
import swal from 'sweetalert';
import { useNavigate } from "react-router-dom";

export default function Dashboard() {
  const user = User.getUser()
  const navigate = useNavigate();
  const [sequenceList, setSequenceList] = useState([])
  const [loader, setLoader] = useState(false);
  const [inputValue, setInputValue] = useState({ searchText: "" });
  const { searchText } = inputValue;

  useEffect(() => {
    getSequenceList();
  }, [])

  const getSequenceList = () => {
    let arr = [];
    arr.push({ P_user_id: user[0].Id });
    // arr.push({ P_id: 136 });
    arr.push({ P_search_text: searchText });
    let p = SerializeClass.getSerializedData(arr);
    let header = {
      headers: { 'Authorization': `Token ${user[0].token}` }
    };
    let url = `https://api.getbound.ai/api/user/getSequenceStats?Params=${p}`;
    axios.get(url, header).then(response => {
      console.log(response);
      if (response.data.code == 200) {
        setSequenceList(response.data.data);
      } else {
        Alert.show("Error!", response.data.msg, "error");
      }
    }).catch(err => {
      console.log(err);
    })
  }

  function UpdateSequence(e, data, index) {
    e.preventDefault();
    let flag = e.target.checked;
    let requestData = new FormData();
    let arr = [];
    arr.push({ P_id: data.sequence_id });
    arr.push({ P_updated_by: user[0].Id });
    arr.push({ P_status_id: flag ? 1 : 2 });
    let p = SerializeClass.getSerializedData(arr);
    requestData.append('Params', p);
    let url = '/api/user/updateSequence';
    setLoader(true)
    HttpCall.postRequest2(url, requestData).then(response => {
      setLoader(false)
      if (response.data.code == 200) {
        Alert.show("Success!", flag == 1 ? "Sequence Activated Successfully." : "Sequence DeActivated Successfully.", "success");
        getSequenceList();
        setLoader(false)
      } else {
        if (response.data.msg.includes("Please upgrade your plan to activate the sequence"))
          Alert.showUpgrade("Plan expired", response.data.msg, "error");
        else
          Alert.show("Error!", response.data.msg, "error");
        setLoader(false)
      }
    }).catch(err => {
      console.log(err);
      setLoader(false)
    })
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValue((prev) => ({ ...prev, [name]: value, }));
  };

  function deleteSequence(e, data) {
    e.preventDefault();
    swal({
      title: "Are you sure?",
      text: "Want to delete Sequence!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          let requestData = new FormData();
          let arr = [];
          arr.push({ P_id: data.sequence_id });
          arr.push({ P_updated_by: user[0].Id });
          let p = SerializeClass.getSerializedData(arr);
          requestData.append('Params', p);
          let url = '/api/user/deleteSequence';
          setLoader(true)
          HttpCall.postRequest2(url, requestData).then(response => {
            setLoader(false)
            if (response.data.code == 200) {
              Alert.show("Success!", "Sequence Deleted Successfully.", "success");
              getSequenceList();
              setLoader(false)
            } else {
              Alert.show("Error!", response.data.msg, "error");
              setLoader(false)
            }
          }).catch(err => {
            console.log(err);
            setLoader(false)
          })
        }
      });
  }

  function goToForm(e, id) {
    e.preventDefault();
    navigate('/dashboard-charts?id=' + id);
  }
  return (
    <>
      <DashboardHeader />
      {/* <div class="customTypeform">
        <i class="mdi mdi-close tutorialclosebtn"></i>
        <div class="customtypeformfield typeform_item01">
          <div class="row">
            <div class="col-md-6">
              <img src="https://getbound.ai/images/header-teamwork.svg" />
            </div>
            <div class="col-md-6">
              <h1>Welcome to Getbound!</h1>
              <p>Automate Your Outreach with Your Personal Sales Assistants</p>
              <button class="optionbtn" id="typeform_btn01">Next</button>
              <ul class="slidercounter">
                <li class="counteractive"></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="customtypeformfield typeform_item02 displaynone">
          <div class="row">
            <div class="col-md-5">
              <img src="https://getbound.ai/images/howitwork-icons/leadlist.png" class="imagecard" />
            </div>
            <div class="col-md-7">
              <h1>Build Your Lead List</h1>
              <p>Effortlessly gather and organize your most important prospects for targeted outreach</p>
              <button class="nextbtn" id="typeform_btn02">Next</button>
              <i class="fa fa-angle-left backbtn" id="typeform_backbtn02"></i>
              <ul class="slidercounter">
                <li class=""></li>
                <li class="counteractive"></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="customtypeformfield typeform_item03 displaynone">
          <div class="row">
            <div class="col-md-5">
              <img src="https://getbound.ai/images/howitwork-icons/sequence.png" class="imagecard" />
            </div>
            <div class="col-md-7">
              <h1>Craft Personalized Sequences</h1>
              <p>Create tailored emails, LinkedIn messages, and phone scripts that make a lasting impression on each prospect</p>
              <button class="nextbtn" id="typeform_btn03">Next</button>
              <i class="fa fa-angle-left backbtn" id="typeform_backbtn03"></i>
              <ul class="slidercounter">
                <li class=""></li>
                <li class=""></li>
                <li class="counteractive"></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="customtypeformfield typeform_item04 displaynone">
          <div class="row">
            <div class="col-md-5">
              <img src="https://getbound.ai/images/howitwork-icons/platform.png" class="imagecard" />
            </div>
            <div class="col-md-7">
              <h1>Integrate with Your Preferred Platform</h1>
              <p>Seamlessly connect Getbound with your preferred email marketing tool, CRM system, or communication platform like LinkedIn, Twitter etc</p>
              <button class="nextbtn" id="typeform_btn04">Next</button>
              <i class="fa fa-angle-left backbtn" id="typeform_backbtn04"></i>
              <ul class="slidercounter">
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class="counteractive"></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="customtypeformfield typeform_item05 displaynone">
          <div class="row">
            <div class="col-md-6">
              <img src="https://getbound.ai/images/robot-01.svg" />
            </div>
            <div class="col-md-6">
              <h1>Assign and Activate Your Leads</h1>
              <p>Connect your carefully curated prospects to your personalized sequence, ensuring they receive the perfect message at the perfect moment</p>
              <button class="nextbtn" id="typeform_btn05">Next</button>
              <i class="fa fa-angle-left backbtn" id="typeform_backbtn05"></i>
              <ul class="slidercounter">
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class="counteractive"></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="customtypeformfield typeform_item06 displaynone custom-minwidth">
          <div class="row">
            <div class="col-md-6">
              <img src="https://getbound.ai/images/details-1-office-worker.svg" />
            </div>
            <div class="col-md-6">
              <h1>Sit Back and Relax</h1>
              <p>Activate your sequence and let Getbound automatically send out your personalized messages, Email & Calls to freeing up your time for building relationships</p>
              <button class="nextbtn" id="typeform_btn06">Next</button>
              <i class="fa fa-angle-left backbtn" id="typeform_backbtn06"></i>
              <ul class="slidercounter">
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class="counteractive"></li>
                <li class=""></li>
                <li class=""></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="customtypeformfield typeform_item07 custom-minwidth displaynone">
          <div class="row">
            <div class="col-md-6">
              <img src="https://getbound.ai/images/robot-02.svg" />
            </div>
            <div class="col-md-6">
              <h1>Real-Time Results at Your Fingertips</h1>
              <p>Stay informed with our intuitive dashboard & monitoring all types of outreach activities</p>
              <button class="nextbtn" id="typeform_btn07">Next</button>
              <i class="fa fa-angle-left backbtn" id="typeform_backbtn07"></i>
              <ul class="slidercounter">
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class="counteractive"></li>
                <li class=""></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="customtypeformfield typeform_item08 custom-minwidth displaynone">
          <div class="row">
            <div class="col-md-6">
              <img src="https://getbound.ai/images/details-2-office-team-work.svg" />
            </div>
            <div class="col-md-6">
              <h1>Impress, Close, and Shine</h1>
              <p>Getbound empowers you to impress your prospects, close deals faster, and take your sales to new heights</p>
              <button class="nextbtn" id="typeform_btn08">Next</button>
              <i class="fa fa-angle-left backbtn" id="typeform_backbtn08"></i>
              <ul class="slidercounter">
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class="counteractive"></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="customtypeformfield typeform_item09 custom-minwidth displaynone">
          <div class="row">
            <div class="col-md-6">
              <img src="https://getbound.ai/images/robot-03.svg" />
            </div>
            <div class="col-md-6">
              <h1>Dedicated Support for Your Success</h1>
              <p>Our dedicated support team is available to assist you whenever you need help or have questions along the way. Your success is our priority</p>
              <button class="optionbtn" id="typeform_btn01">Let's Start</button>
            </div>
          </div>
        </div>
      </div> */}
      <div className="container-fluid page-body-wrapper">
        <SideMenu />
        {loader && <Loader />}
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-md-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Dashboard</h4>
                    <p className="card-description">
                      Note: Manage your sequence here
                    </p>
                    <div className="form-group customsearchbar">
                      <div className="input-group">
                        <input onChange={handleChange} value={searchText} name="searchText" type="text" className="form-control" placeholder="Search Sequence" aria-label="Search" />
                        <div className="input-group-append">
                          <button className="btn btn-sm btn-primary" type="button" onClick={getSequenceList}>Search</button>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <tbody>
                          {sequenceList.length == 0 && (
                            <p className="card-description">
                              <a href="sequence" className="policylink">Create Sequence</a>
                            </p>)
                          }
                          {sequenceList.length > 0 && sequenceList.map((data, key) => (<tr key={key}>
                            <td className="switchsize">
                              <label className="switch">
                                <input type="checkbox" checked={data.status_name == 'Active' ? true : false} onChange={(e) => { UpdateSequence(e, data, key) }} />
                                <span className="slider round"></span>
                              </label>
                            </td>
                            <td className="no-left-padding"><a href={"/sequence-detail?sequence_id=" + data.sequence_id}>{data.sequence_name}</a></td>
                            <td className="text-center customtablecell"><label>{data.status_name}</label></td>
                            <td className="text-center customtablecell"><b>{data.sequence_days}</b><br /> Total Sequence Cycle</td>
                            <td className="text-center customtablecell"><b>{data.lead_list_count}</b><br /> Lead list</td>
                            <td className="text-center customtablecell"><b>{data.current_cycle}</b><br /> Current Cycle</td>
                            <td className="text-center customtablecell"><b>{data.response}</b><br /> Response/Meetings</td>
                            {/* <td className="text-center customtablecell"><b>{data.remaining}</b><br />Remaining</td> */}
                            <td>
                              {/* <a type="button" onClick={(e) => goToForm(e, data)} className="btn btn-outline-info btn-sm marginright10">Details</a> */}
                              <button type="button" onClick={(e) => goToForm(e, data.sequence_id)} className="btn btn-outline-primary btn-sm"><i className="mdi mdi-chart-areaspline"><a href={"/dashboard-charts?sequence_id=" + data.sequence_id}></a></i></button>
                              <span> </span>
                              <button type="button" className="btn btn-outline-danger btn-sm" onClick={(e) => { deleteSequence(e, data) }}><i className="mdi mdi-delete"></i></button>
                            </td>
                          </tr>))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  )
}

// $(document).ready(function () {
//   $("#typeform_btn01").click(function () {
//     $(".typeform_item01").addClass("displaynone");
//     $(".typeform_item02").removeClass("displaynone");
//   });
// });

// $(document).ready(function () {
//   $("#typeform_btn02").click(function () {
//     $(".typeform_item02").addClass("displaynone");
//     $(".typeform_item03").removeClass("displaynone");
//   });
//   $("#typeform_backbtn02").click(function () {
//     $(".typeform_item02").addClass("displaynone");
//     $(".typeform_item01").removeClass("displaynone");
//   });
// });

// $(document).ready(function () {
//   $("#typeform_btn03").click(function () {
//     $(".typeform_item03").addClass("displaynone");
//     $(".typeform_item04").removeClass("displaynone");
//   });
//   $("#typeform_backbtn03").click(function () {
//     $(".typeform_item03").addClass("displaynone");
//     $(".typeform_item02").removeClass("displaynone");
//   });
// });

// $(document).ready(function () {
//   $("#typeform_btn04").click(function () {
//     $(".typeform_item04").addClass("displaynone");
//     $(".typeform_item05").removeClass("displaynone");
//   });
//   $("#typeform_backbtn04").click(function () {
//     $(".typeform_item04").addClass("displaynone");
//     $(".typeform_item03").removeClass("displaynone");
//   });
// });

// $(document).ready(function () {
//   $("#typeform_btn05").click(function () {
//     $(".typeform_item05").addClass("displaynone");
//     $(".typeform_item06").removeClass("displaynone");
//   });
//   $("#typeform_backbtn05").click(function () {
//     $(".typeform_item05").addClass("displaynone");
//     $(".typeform_item04").removeClass("displaynone");
//   });
// });

// $(document).ready(function () {
//   $("#typeform_btn06").click(function () {
//     $(".typeform_item06").addClass("displaynone");
//     $(".typeform_item07").removeClass("displaynone");
//   });
//   $("#typeform_backbtn06").click(function () {
//     $(".typeform_item06").addClass("displaynone");
//     $(".typeform_item05").removeClass("displaynone");
//   });
// });

// $(document).ready(function () {
//   $("#typeform_btn07").click(function () {
//     $(".typeform_item07").addClass("displaynone");
//     $(".typeform_item08").removeClass("displaynone");
//   });
//   $("#typeform_backbtn07").click(function () {
//     $(".typeform_item07").addClass("displaynone");
//     $(".typeform_item06").removeClass("displaynone");
//   });
// });

// $(document).ready(function () {
//   $("#typeform_btn08").click(function () {
//     $(".typeform_item08").addClass("displaynone");
//     $(".typeform_item09").removeClass("displaynone");
//   });
//   $("#typeform_backbtn08").click(function () {
//     $(".typeform_item08").addClass("displaynone");
//     $(".typeform_item07").removeClass("displaynone");
//   });
// });